import { Tooltip } from 'antd';
import Image from 'next/image';
import { ReactNode } from 'react';

import emptyProfilePhoto from '../../../assets/images/emptyProfilePhoto.png';
import theme from '../../../assets/theme';
import { useUserPhoto } from '../../../hooks/useUserPhoto';
import { ProfileCircle } from '../../ProfileCircle';
import ConditionalWrapper from '../ConditionalWrapper';
const UserProfileCircle = ({
  uid,
  userName,
  showHoveranimation = false,
  radius,
}: {
  uid: string;
  userName?: string;
  showHoveranimation?: boolean;
  radius?: number;
}) => {
  const { thumbnail: profileImage } = useUserPhoto(uid);

  return (
    <ConditionalWrapper
      condition={!!userName && userName !== '-'}
      truthyWrapper={(children: ReactNode) => (
        <Tooltip placement="top" title={userName}>
          {children}
        </Tooltip>
      )}
    >
      <ProfileCircle
        $background={!!profileImage ? undefined : '#535454'}
        $showHoverAnimation={showHoveranimation}
        $color={theme.colors.white}
        $radius={radius}
        style={
          !!profileImage ? undefined : { border: `2px ${theme.colors.background} solid` }
        }
      >
        <>
          {profileImage && (
            <Image
              style={{ borderRadius: '50%' }}
              width={'100%'}
              height={'100%'}
              src={profileImage || emptyProfilePhoto}
              alt="profile"
            />
          )}
          {!profileImage && (
            <span style={{ fontWeight: 'bold' }}>
              {userName?.slice(0, 1).toLocaleUpperCase()}
            </span>
          )}
        </>
      </ProfileCircle>
    </ConditionalWrapper>
  );
};
export default UserProfileCircle;
